export default __webpack_public_path__ + "static/media/pending.400d13f9.svg";